import React from 'react';
import PropTypes from 'prop-types';

import './RadioButton.scss';

const RadioButton = props => (
  <div className={`RadioButton${props.x2 ? ' x2' : ''}`} id={props.id} onClick={props.handleSelect}>
    <span className={`item${props.checked ? ' active' : ''}`}>
      <span className={`${props.checked ? ' active' : ''}`} />
    </span>
    <span className={`label${props.checked ? ' active' : ''}`}>{props.label}</span>
  </div>
);

RadioButton.propTypes = {
  'checked': PropTypes.bool.isRequired,
  'label': PropTypes.string.isRequired,
  'handleSelect': PropTypes.func,
  'id': PropTypes.string,
  'x2': PropTypes.bool,
};

export default RadioButton;
